import axios from "../utils/axios";

export async function getReleaseTitle(keyword: string) {
  const response = await axios.get("/get-release-title", {
    params: {
      keyword: keyword,
    },
  });
  if (response.status === 200) return response.data;
  else return [];
}

export async function getLabelName(keyword: string) {
  const response = await axios.get("/get-label-name", {
    params: {
      keyword: keyword,
    },
  });
  if (response.status === 200) return response.data;
  else return [];
}

export async function getPrimaryArtists(keyword: string) {
  const response = await axios.get("/get-artists", {
    params: {
      keyword: keyword,
    },
  });
  if (response.status === 200) return response.data;
  else return [];
}

export async function getArtistRole(keyword: string) {
  const response = await axios.get("/get-artist-role", {
    params: {
      keyword: keyword,
    },
  });
  if (response.status === 200) return response.data;
  else return [];
}

export async function getFormate(keyword: string) {
  const response = await axios.get("/get-format", {
    params: {
      keyword: keyword,
    },
  });
  if (response.status === 200) return response.data;
  else return [];
}

export async function getClientListByYear(keyword: string) {
  const response = await axios.get("/get-client-list-by-year", {
    params: {
      keyword: keyword,
    },
  });
  if (response.status === 200) return response.data;
  else return [];
}

export async function getLicensor(keyword: string) {
  const response = await axios.get("/get-licence", {
    params: {
      keyword: keyword,
    },
  });
  if (response.status === 200) return response.data;
  else return [];
}

export async function getSinger(keyword: string) {
  const response = await axios.get("/get-singer", {
    params: {
      keyword: keyword,
    },
  });
  if (response.status === 200) return response.data;
  else return [];
}

export async function getComposer(keyword: string) {
  const response = await axios.get("/get-composers", {
    params: {
      keyword: keyword,
    },
  });
  if (response.status === 200) return response.data;
  else return [];
}

export async function getConductor(keyword: string) {
  const response = await axios.get("/get-conductor", {
    params: {
      keyword: keyword,
    },
  });
  if (response.status === 200) return response.data;
  else return [];
}

export async function getOrchestraChoir(keyword: string) {
  const response = await axios.get("/get-orchestra-choir", {
    params: {
      keyword: keyword,
    },
  });
  if (response.status === 200) return response.data;
  else return [];
}

export async function getCopyrightP(keyword: string) {
  const response = await axios.get("/get-copyrightp", {
    params: {
      keyword: keyword,
    },
  });
  if (response.status === 200) return response.data;
  else return [];
}

export async function getSeries(keyword: string) {
  const response = await axios.get("/get-series", {
    params: {
      keyword: keyword,
    },
  });
  if (response.status === 200) return response.data;
  else return [];
}

export async function getTrackTitle(keyword: string) {
  const response = await axios.get("/get-track-title", {
    params: {
      keyword: keyword,
    },
  });
  if (response.status === 200) return response.data;
  else return [];
}

export async function getFeature(keyword: string) {
  const response = await axios.get("/get-feature", {
    params: {
      keyword: keyword,
    },
  });
  if (response.status === 200) return response.data;
  else return [];
}

export async function TrackList(
  data: any,
  signal: AbortSignal
): Promise<any[]> {
  try {
    const response: any = await axios.post("/trackList", data, { signal });

    if (response.status === 200) {
      return response.data;
    }
    if (signal.aborted) {
      console.log("Request aborted");
      return [];
    }
    return [];
  } catch (error) {
    console.error("Error in TrackList:", error);
    if (signal.aborted) {
      console.log("Request aborted");
      return [];
    }
    return [];
  }
}

export async function getTerritories() {
  const response = await axios.get("/get-territories");
  if (response.status === 200) return response.data;
  else return [];
}

export async function getCityList(city: string) {
  const response = await axios.get(`/get-city-list`, {
    params: {
      keyword: city
    },
  });
  if (response.status === 200) return response.data;
  else return [];
}
